export class User {
  constructor(username?: string, password?: string) {
  }
}



// WEBPACK FOOTER //
// ./src/app/models/user.ts